import { User } from '@elio/emanager-front/auth/model';
import { ElioError } from '@elio/shared/models';
import { createAction, props } from '@ngrx/store';
import { OfferView } from '../../model/src/lib/offer-view.model';

const loadOffersSuccess = createAction('[Offers Effect] Load offers SUCCESS', props<{ offers: OfferView[] }>());
const loadOffersFailure = createAction('[Offers Effect] Load offers FAILURE', props<{ error: ElioError }>());
const NO_OP_CACHE = createAction('[Offers Effect] No operation: cache');

const loadPublicationsCountSuccess = createAction(
  '[Offers Effect] Load publications count SUCCESS',
  props<{ publicationsCount: Record<number, number> }>()
);
const loadPublicationsCountFailure = createAction(
  '[Offers Effect] Load publications count FAILURE',
  props<{ error: ElioError }>()
);

const leaveUniqueOffer = createAction('[Offers Effect] professional leaves his unique offer');
const leaveOneOffer = createAction(
  '[Offers Effect] professional leaves one of his offers',
  props<{ user: User; offerId: number }>()
);

const leaveUniqueHeadquarter = createAction('[Offers Effect] professional leaves his unique headquarter');

const leaveOneHeadquarter = createAction(
  '[Offers Effect] professional leaves one of his headquarters',
  props<{ user: User; hqId: number }>()
);

export const OffersEffectActions = {
  loadOffersSuccess,
  loadOffersFailure,
  NO_OP_CACHE,
  loadPublicationsCountSuccess,
  loadPublicationsCountFailure,
  leaveUniqueOffer,
  leaveOneOffer,
  leaveUniqueHeadquarter,
  leaveOneHeadquarter,
};
